import React, { Component } from 'react'
import { Row, Col, Glyphicon, DropdownButton, MenuItem } from 'react-bootstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { queueSave } from '../../common/utils'
import { CSVLink } from 'react-csv/lib'

class RentalFilter extends Component {
    constructor(p) {
        super(p)

        this.state = {
            searchString: '',
            selectedLocks: {},
            selectedRentalCompanys: {},
            selectedCustomers: {}
        }
    }

    toggleSelect = (type, obj) => {
        const filterType = `selected${type}s`

        if (type == "Vendor") obj = { _id: obj }

        var state = { ...this.state }

        if (this.state[filterType][obj._id]) {
            delete state[filterType][obj._id]
        } else {
            state[filterType][obj._id] = obj
        }

        this.setState({ [filterType]: state[filterType] }, () => this.props.updateFilter(this.state))
    }

    updateSearch = (e) => {
        queueSave('rentalSearchString', e.target.value, 500).then(t => {
            this.setState({ ...this.state, searchString: t[t.length - 1] }, () => this.props.updateFilter(this.state))
        })
    }

    render() {
        const { csvData } = this.props

        const { selectedLocks, selectedRentalCompanys, selectedCustomers } = this.state

        const selectedLocksCount = Object.keys(selectedLocks).length
        const selectedRentalCompanysCount = Object.keys(selectedRentalCompanys).length
        const selectedCustomersCount = Object.keys(selectedCustomers).length

        const { rentals } = this.props

        const locks = []
        for (var lock of rentals.map(rental => rental.lock)) {
            if (!locks.some(l => l._id == lock._id)) locks.push(lock)
        }

        const rentalCompanies = []
        for (var company of rentals.map(rental => rental.rentalCompany)) {
            if (!rentalCompanies.some(c => c._id == company._id)) rentalCompanies.push(company)
        }

        const customers = []
        for (var customer of rentals.map(rental => rental.customer)) {
            if (!customers.some(c => c._id == customer._id)) customers.push(customer)
        }

        return (
            <div className="flex">
                <div style={{ flex: 1, flexWrap: 'nowrap', justifyContent: 'space-evenly' }} className="flex">                    
                    <DropdownButton className="delivery-filter-container" title={selectedLocksCount > 0 ? "Valda: " + selectedLocksCount + " " : 'Platser '} id="bg-nested-dropdown">
                    <MenuItem
                        style={{ backgroundColor: "rgb(230, 230, 230)" }}
                        className="dropdown-menu-item"
                        onSelect={() => this.setState({ ...this.state, selectedLocks: {} }, () => this.props.updateFilter(this.state))}>
                        <div>Återställ filter </div>
                    </MenuItem>
                    <div style={{ maxHeight: "410px", overflowY: "scroll" }}>
                        {locks.map((lock, i) => {
                            return (
                                <MenuItem
                                    key={i}
                                    onSelect={() => this.toggleSelect('Lock', lock)}
                                    className="dropdown-menu-item"
                                    eventKey={i}>


                                    {selectedLocks[lock._id] !== undefined ?
                                        <Glyphicon glyph="glyphicon glyphicon-check" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                        :
                                        <Glyphicon glyph="glyphicon glyphicon-unchecked" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                    }


                                    <div style={{ marginLeft: "5px", textAlign: "left", color: "black" }}>{lock.custom_name}</div>

                                </MenuItem>)
                        })}
                    </div>
                </DropdownButton>
                    <DropdownButton className="delivery-filter-container" title={selectedRentalCompanysCount > 0 ? "Valda: " + selectedRentalCompanysCount + " " : 'Uthyrare '} id="bg-nested-dropdown">
                    <MenuItem
                        style={{ backgroundColor: "rgb(230, 230, 230)" }}
                        className="dropdown-menu-item"
                        onSelect={() => this.setState({ ...this.state, selectedRentalCompanys: {} }, () => this.props.updateFilter(this.state))}>
                        <div>Återställ filter </div>
                    </MenuItem>
                    <div style={{ maxHeight: "410px", overflowY: "scroll" }}>
                        {rentalCompanies.map((company, i) => {
                            return (
                                <MenuItem
                                    key={i}
                                    onSelect={() => this.toggleSelect('RentalCompany', company)}
                                    className="dropdown-menu-item"
                                    eventKey={i}>


                                    {selectedRentalCompanys[company._id] !== undefined ?
                                        <Glyphicon glyph="glyphicon glyphicon-check" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                        :
                                        <Glyphicon glyph="glyphicon glyphicon-unchecked" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                    }


                                    <div style={{ marginLeft: "5px", textAlign: "left", color: "black" }}>{company.name}</div>

                                </MenuItem>)
                        })}
                    </div>
                </DropdownButton>
                    <DropdownButton className="delivery-filter-container" title={selectedCustomersCount > 0 ? "Valda: " + selectedCustomersCount + " " : 'Beställare '} id="bg-nested-dropdown">
                        <MenuItem
                            style={{ backgroundColor: "rgb(230, 230, 230)" }}
                            className="dropdown-menu-item"
                            onSelect={() => this.setState({ ...this.state, selectedCustomers: {} }, () => this.props.updateFilter(this.state))}>
                            <div>Återställ filter </div>
                        </MenuItem>
                        <div style={{ maxHeight: "410px", overflowY: "scroll" }}>
                            {customers.map((customer, i) => {
                                return (
                                    <MenuItem
                                        key={i}
                                        onSelect={() => this.toggleSelect('Customer', customer)}
                                        className="dropdown-menu-item"
                                        eventKey={i}>


                                        {selectedCustomers[customer._id] !== undefined ?
                                            <Glyphicon glyph="glyphicon glyphicon-check" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                            :
                                            <Glyphicon glyph="glyphicon glyphicon-unchecked" style={{ color: "grey", marginRight: "5px", marginLeft: "5px", float: "left" }} />
                                        }


                                        <div style={{ marginLeft: "5px", textAlign: "left", color: "black" }}>{customer.name} {customer.surname}</div>

                                    </MenuItem>)
                            })}
                        </div>
                    </DropdownButton>
                </div>

                <div
                    style={{ borderRadius: 10, height: 42, fontSize: 14, cursor: 'default', flex: 1 }}
                    className="delivery-filter-container">
                    <input
                        type="text"
                        onChange={this.updateSearch}
                        placeholder="Sök"
                        className="Sök" />
                </div>

                <div style={{ flex: 1, flexWrap: 'nowrap', justifyContent: 'space-evenly' }} className="flex">
                    <DatePicker
                        locale="sv"
                        dateFormat="dd/MM/yyyy"
                        className="delivery-filter-container"
                        selected={this.props.initialValues.startDate.toDate()}
                        onChange={(e) => this.props.changeDate(e, 'start')} />
                    <DatePicker
                        locale="sv"
                        dateFormat="dd/MM/yyyy"
                        className="delivery-filter-container"
                        style={{ cursor: "text" }}
                        selected={this.props.initialValues.endDate.toDate()}
                        onChange={(e) => this.props.changeDate(e, 'end')} />

                {csvData && (
                    <CSVLink
                        filename="HyrverktygExport.csv"
                        className="smallQbutton"
                        separator=";"
                        data={csvData}
                        style={{ borderRadius: 10 }}>
                            Exportera
                    </CSVLink>
                )}
                </div>  
            </div>
        )
    }
}

const mapProps = state => {
    return {
    }
}

const mapDispatch = dispatch => {
    return {
    }
}

export default connect(mapProps, mapDispatch)(RentalFilter)